import { z } from 'zod';
export const trainingWorkforceProfileStatusCapability = 'training.workforce-profile-status.v1';
const countSchema = z.number().int().nonnegative();
export const trainingWorkforceProfileStatusSchema = z.strictObject({
    contractVersion: z.literal(trainingWorkforceProfileStatusCapability),
    factKind: z.literal('training-workforce-profile-status'),
    membershipId: z.string().uuid(),
    observedAt: z.string().datetime({ offset: true }),
    assignments: z.strictObject({
        total: countSchema,
        assigned: countSchema,
        inProgress: countSchema,
        completed: countSchema,
        waived: countSchema,
        overdue: countSchema,
        nearestDueAt: z.string().datetime({ offset: true }).nullable(),
    }).superRefine((value, context) => {
        if (value.total !== value.assigned + value.inProgress + value.completed + value.waived) {
            context.addIssue({
                code: 'custom',
                path: ['total'],
                message: 'Training assignment status counts must reconcile to the total.',
            });
        }
        if (value.overdue > value.assigned + value.inProgress) {
            context.addIssue({
                code: 'custom',
                path: ['overdue'],
                message: 'Overdue Training assignments cannot exceed open assignments.',
            });
        }
    }),
    completions: z.strictObject({
        completedCourses: countSchema,
        latestCompletedAt: z.string().datetime({ offset: true }).nullable(),
    }),
    certifications: z.strictObject({
        totalCurrent: countSchema,
        active: countSchema,
        expiring: countSchema,
        expired: countSchema,
        nonExpiring: countSchema,
        nearestExpiryOn: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable(),
        recordBasis: z.literal('tenant-attested'),
        issuerVerification: z.literal('not-verified-by-crest'),
    }).superRefine((value, context) => {
        if (value.totalCurrent !== value.active + value.expiring + value.expired + value.nonExpiring) {
            context.addIssue({
                code: 'custom',
                path: ['totalCurrent'],
                message: 'Current Training certification status counts must reconcile to the total.',
            });
        }
    }),
});
export const trainingWorkforceProfileStatusResponseSchema = z.strictObject({
    data: trainingWorkforceProfileStatusSchema,
});
//# sourceMappingURL=training-workforce-profile-status.contract.js.map